/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type representing the entity types that can have saved views
 */
export enum SavedViewModelType {
    CONVERSATION = 'CONVERSATION',
}
